import type { DocNode } from '@atlaskit/adf-schema';

import type { ConfluenceUpdatePageCommandProperties } from '@atlassian/rovo-content-bridge-api-commands';

import type { ConfluencePageUpdateCommandProcessor } from '../stream-processors/update-command-processor';

import { type PassThroughCommandProperties } from './types/command-handler-types';
import { StreamingCommandHandler } from './types/streaming-command-handler';

export class UpdateCommandHandler extends StreamingCommandHandler<ConfluenceUpdatePageCommandProperties> {
	constructor(
		properties: PassThroughCommandProperties,
		private updateCommandProcessor: ConfluencePageUpdateCommandProcessor,
	) {
		super(properties, 'update');
	}

	async process(params: ConfluenceUpdatePageCommandProperties): Promise<void> {
		await this.updateCommandProcessor.streamChunk(params.data.toolCalls, params.isStreamComplete);
	}

	async finishAction(): Promise<DocNode | undefined> {
		await this.updateCommandProcessor.finish();
		return undefined;
	}

	abort(): void {
		this.updateCommandProcessor.abort();
	}
}
